import { useCallback, useEffect, useState } from "react"
import { changeSubscriptionPlan } from "../../../../redux/checkout/actions"
import API_LIST from "../../../../utils/apiList"
import { clickStreamUser, SessionKeys } from "../../../../utils/AppUtils"
import CONFIG from "../../../../utils/config"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { SubscriptionCardGreenTick, SubscriptionCardRedCross } from "../../../../utils/SvgComps"
import CartPopUpComponent from "../../DetailPage/CartPopUp/CartPopUpComponent"
import ConfirmModal from "../../../modal/ConfirmModal"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import _ from "lodash"
const NewSubscriptionPriceCardComponent = (props) => {

  const {
    cardId, cardTitle, cardPrice, cardThumbnail, isPaid, cardLogo,
    cardPunchLine, sessionCount, roleplayCount, cardPriceInfo,
    rewardPoint, btnName, isLoading, cardPlanTitle, isUpgradePlan,
    isDowngradePlan, isLoggedIn, isCurrentlySubscribed,
    subscribedPlanName, setMainPageLoading, subscribedBillingType, providerLogo,
    foundationCourses, videoAccess, mobileAppAccess, exclusiveOffers,
    technicalSupport, niitCoursesDiscount, narCertificationDiscount,
    partnerCoursesDiscount, coachingServiceDiscount, aiCourseDiscount,
  } = props

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const authBroker = useSelector(state => state.auth.authBroker)

  const [isOpen, setIsOpen] = useState(false)
  const [productData, setProductData] = useState({})
  const [confirmModal, setConfirmModal] = useState(false)
  const [confirmMsg, setConfirmMsg] = useState('')
  const [isConfirm, setIsConfirm] = useState(true)

  const loadProductData = useCallback(() => {

    setProductData({
      id: cardId,
      title: cardPlanTitle,
      logoURL: providerLogo,
      logoAltText: '',
      bannerURL: cardThumbnail,
      tagsArray: [`Xsel ${cardTitle} subscription`],
      description: '',
      price: '',
      isPaid: true,
      priceInfo: cardPriceInfo,
      isUpgradePlan: isUpgradePlan,
      isDowngradePlan: isDowngradePlan,
      subscribedPlanName: subscribedPlanName,
      cardTitle: cardTitle
    })
  }, [subscribedPlanName])

  useEffect(() => {
    console.log('PRODUCT DATA', productData)
  }, [productData])

  const subscriptionBtnLogic = () => {
    if (isPaid) {
      clickStreamUser('subscription-btn-clicked', {
        is_guest_user: !isLoggedIn,
        user_id: isLoggedIn ? sessionStorage.getItem(SessionKeys.USER_ID) : '',
        btn_name: btnName,
        redirect_to: 'shopping-modal'
      })
      loadProductData()
      setIsOpen(true)
    } else if (!isLoggedIn) {
      clickStreamUser('subscription-btn-clicked', {
        is_guest_user: !isLoggedIn,
        user_id: isLoggedIn ? sessionStorage.getItem(SessionKeys.USER_ID) : '',
        btn_name: btnName,
        redirect_to: 'sign-up'
      })
      navigate("/sign-up?p=1")
    } else {
      setIsConfirm(true)
      setConfirmMsg(`You are already subscribed to higher plan (Xsel ${subscribedPlanName}). 
            Switching to lower plan, will reduced the benefits. Are you sure, you want to switch to Xsel ${cardTitle}`)
      setConfirmModal(true)
    }
  }

  const changeSubPlan = () => {
    if (!isPaid) {
      console.log('CHANGE SUB PLAN')
      setMainPageLoading(true)
      dispatch(
        changeSubscriptionPlan({
          URL: `${CONFIG.API_URL_BROKER}/${API_LIST.ECOM_API.CHANGE_SUBSCRIPTION_TO_BASIC}`,
          payload: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            subscription_id: cardId
          },
          isJSON: true,
          method: 'post'
        })
      )
    }
  }

  return (
    <>
      <div className={`plan ${isCurrentlySubscribed ? "active" : ""}`}>
        <div className="plan-header">
          <OverlayTrigger
            overlay={<Tooltip id="tooltip-disabled">{cardTitle}</Tooltip>}
          >
            <div className="planname">{cardTitle}</div>
          </OverlayTrigger>
          <button
            type="button"
            className={`reset-btn btn-reset w-100 ${isCurrentlySubscribed ? "cursor-not-allowed" : ""
              }`}
              onClick={() => {if (!isCurrentlySubscribed) subscriptionBtnLogic()}}
          >
            <div className="price">
              {cardPrice === "Free" ? (
                <>
                  FREE{authBroker.payload?.user?.is_corporate && <sup>*</sup>}
                </>
              ) : (
                // <></>
                // <>{cardPrice.split('.')[0]}<sup>{cardPrice.split('.')[1]}</sup></>
                <div dangerouslySetInnerHTML={{ __html: cardPrice }}></div>
              )}
            </div>
          </button>
          <div className="month">PER MONTH</div>
        </div>

        <div className="plan-details">
          <ul>
            <li>{foundationCourses}</li>
            <li>{videoAccess}</li>
            <li>
              {_.toInteger(sessionCount) == 0 ? <SubscriptionCardRedCross /> : <SubscriptionCardGreenTick />}
            </li>
            {false &&<li>{mobileAppAccess ? <SubscriptionCardGreenTick /> : <>NA</>}</li>}
            {/* Exclusive Offers */}
            <li>{exclusiveOffers ? <SubscriptionCardGreenTick /> : <>NA</>}</li>
            <li>
              {rewardPoint} point{rewardPoint > 1 ? "s" : ""} (per $10 spent)
            </li>
            {/* Roleplay Access */}
            {/* <li>{roleplayCount}</li> */}
            <li>
              {technicalSupport ? <SubscriptionCardGreenTick /> : <>NA</>}
            </li>
            {/* Niit Courses Discount */}
            <li>{niitCoursesDiscount ? `${niitCoursesDiscount}%` : <>NA</>}</li>
            {/* NAR Discount */}
            <li>
              {narCertificationDiscount ? (
                `${narCertificationDiscount}%`
              ) : (
                <>NA</>
              )}
            </li>
            {/* Exper Partner Course Discount */}
            <li>{partnerCoursesDiscount ? `${aiCourseDiscount}%` : <>NA</>}</li>
            {/* Coaching Service Discount */}
            <li>
              {coachingServiceDiscount ? (
                `${coachingServiceDiscount}%`
              ) : (
                <>NA</>
              )}
            </li>
            {/* AI Course Discount */}
            <li>{aiCourseDiscount ? `${aiCourseDiscount}%` : <>NA</>}</li>
          </ul>
        </div>
      </div>
      {!isLoading && isOpen && (
        <CartPopUpComponent
          isOpen={isOpen}
          productData={productData}
          closeAction={() => setIsOpen(false)}
          isSubscription={true}
          setMainPageLoading={setMainPageLoading}
        />
      )}
      {!isLoading && confirmModal && (
        <ConfirmModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          showModalMsg={confirmMsg}
          isConfirm={isConfirm}
          confirmId=""
          confirmAction={() => {
            setConfirmModal(false);
            changeSubPlan();
          }}
          isRightIcon=""
        />
      )}
    </>
  );
}

export default NewSubscriptionPriceCardComponent